export enum ServiceProviderCommissionCalculationType {
  Percentage = 1,
  Fixed = 2,
}
